import React from 'react';

/**
 * Instant feedback while a lazy route chunk loads. Mirrors the web app's
 * route `loading.tsx` shells: keep chrome mounted and swap only the page
 * body so navigation never feels frozen.
 */
export const RouteLoadingShell: React.FC<{ label?: string }> = ({
  label = 'Loading',
}) => (
  <div
    className="flex min-h-[40vh] w-full flex-col gap-3 py-2"
    aria-busy="true"
    aria-label={label}
  >
    <div className="h-8 w-48 animate-pulse rounded-lg bg-slate-200 dark:bg-slate-700" />
    <div className="min-h-[28vh] flex-1 animate-pulse rounded-xl bg-slate-100 dark:bg-slate-800/60" />
    <div className="grid gap-3 sm:grid-cols-2">
      <div className="h-24 animate-pulse rounded-xl bg-slate-100 dark:bg-slate-800/60" />
      <div className="h-24 animate-pulse rounded-xl bg-slate-100 dark:bg-slate-800/60" />
    </div>
  </div>
);

export default RouteLoadingShell;
